export const DEFAULT_LOAN_AMOUNT = 2500000;
export const MIN_LOAN_AMOUNT = 100000;
export const MAX_LOAN_AMOUNT = 50000000;
export const LOAN_AMOUNT_STEP = 100000;

export const DEFAULT_INTEREST_RATE = 8.5;
export const MIN_INTEREST_RATE = 6;
export const MAX_INTEREST_RATE = 18;
export const INTEREST_RATE_STEP = 0.25;

export const DEFAULT_TENURE_YEARS = 20;
export const MIN_TENURE_YEARS = 1;
export const MAX_TENURE_YEARS = 30;
export const TENURE_STEP_YEARS = 1;

const MONTHS_PER_YEAR = 12;
const PERCENT = 100;

export const formatINR = (val) => `₹${Math.round(val).toLocaleString('en-IN')}`;

export const calculateEMI = (amount, annualRate, tenureYears) => {
  const monthlyRate = annualRate / MONTHS_PER_YEAR / PERCENT;
  const months = tenureYears * MONTHS_PER_YEAR;
  const factor = Math.pow(1 + monthlyRate, months);
  const emi = (amount * monthlyRate * factor) / (factor - 1);
  const totalPayment = emi * months;

  return {
    emi,
    totalPayment,
    totalInterest: totalPayment - amount,
    principalPct: (amount / totalPayment) * PERCENT,
  };
};
